module.exports = __webpack_public_path__ + "img/lindianLogo.81c6598e.png";